import { collection, getDocs, doc, updateDoc } from "firebase/firestore";
import { dbAML as db } from "../../../../../../backend/firebaseconfig";

async function getExperianResponseDocRef(ownerEmail, checkId) {
  const path = `AML Checks/${ownerEmail}/Checks/${checkId}/Experian Response`;
  const colRef = collection(db, path);
  const snap = await getDocs(colRef);

  if (snap.empty) throw new Error("No Experian Response doc found.");

  const first = snap.docs[0];
  return doc(db, colRef.path, first.id);
}

export async function saveReasonOverride({
  ownerEmail,
  checkId,
  ref,
  reasons,
  rcaDetails,
}) {
  // console.groupCollapsed("[saveReasonOverride]");
  // console.log("meta:", { ownerEmail, checkId, ref });
  // console.log("reasons:", reasons);

  const targetDocRef = await getExperianResponseDocRef(ownerEmail, checkId);

  await updateDoc(targetDocRef, {
    [`reasonsByRef.${ref}`]: {
      reasons: Array.isArray(reasons) ? reasons : [],
      timestamp: new Date().toISOString(),
      rcaDetails: rcaDetails || "",
    },
  });

  // console.log(" saved with timestamp");
  // console.groupEnd();
}

export async function clearReasonOverride({ ownerEmail, checkId, ref }) {
  // console.groupCollapsed("[clearReasonOverride]");
  // console.log("meta:", { ownerEmail, checkId, ref });

  const targetDocRef = await getExperianResponseDocRef(ownerEmail, checkId);

  await updateDoc(targetDocRef, {
    [`reasonsByRef.${ref}`]: {
      reasons: [],
      timestamp: new Date().toISOString(),
      rcaDetails: "",
    },
  });

  // console.log(" cleared with timestamp");
  // console.groupEnd();
}
